import * as _ from 'underscore';

import { IViewDetailInfo, IViewInfo } from '../models/IViewInfo';
import { IWorkbookParentInfo } from '../models/IWorkbookInfo';
import { IRecent } from '../ServerApi/types/IRecent';
import { IViewUsageInfo } from '../ServerApi/types/IUsageInfo';
import { IView, IViewDetail } from '../ServerApi/types/IView';
import { MapperHelper } from './MapperHelper';
import { ProjectMapper } from './ProjectMapper';
import { UserMapper } from './UserMapper';
import { WorkbookMapper } from './WorkbookMapper';

export module ViewMapper {

  const M = MapperHelper;

  export function map(
      serverApiViews: IView[],
      workbooks: _.Dictionary<IWorkbookParentInfo>,
      usageInfoMaxValues: IViewUsageInfo,
      favoriteViews: _.Dictionary<any> = {},
      recents: _.Dictionary<IRecent> = {}): IViewInfo[] {

    return _.map(serverApiViews, (v: IView): IViewInfo => {
      return {
        favorite:              !!favoriteViews[v.id],
        id:                    v.id,
        luid:                  v.luid,
        index:                 M.toNumber(v.index),
        name:                  v.name,
        path:                  v.path,
        tags:                  M.sortTags(v.tags),
        thumbnailUrl:          v.thumbnailUrl,
        updatedAt:             M.toDate(v.updatedAt),
        usageInfo:             v.usageInfo || <IViewUsageInfo> {},
        usageInfoMaxValues:    usageInfoMaxValues || <IViewUsageInfo> {},
        workbook:              workbooks[v.workbookId],
        contentType:           'view',
        lastAccessedAt:        (recents[v.id] && recents[v.id].lastAccessedAt) || undefined
      };
    });
  }

  export function mapDetail(v: IViewDetail): IViewDetailInfo {
    return {
      createdAt:      M.toDate(v.createdAt),
      editUrl:        v.editUrl,
      favorite:       v.favorite,
      hitsTimeSeries: v.hitsTimeSeries,
      id:             v.id,
      luid:                  v.luid,
      index:          M.toNumber(v.index),
      name:           v.name,
      path:           v.path,
      tags:           M.sortTags(v.tags),
      thumbnailUrl:   v.thumbnailUrl,
      updatedAt:      M.toDate(v.updatedAt),
      contentType:    'view',
      workbook:       WorkbookMapper.mapParent(
                        v.workbook,
                        UserMapper.mapOne(v.owner),
                        ProjectMapper.mapName(v.project)),
      sheetType:      v.sheetType
    };
  }

  export function mapFromCRASS(content: any): IViewInfo{
    return {
        favorite:              false, //missing
        id:                    content.id + '',
        luid:                  content.luid,
        index:                 M.toNumber(content.sheetNumber),
        name:                  content.title,
        path:                  content.path,
        tags:                  M.sortTags(content.tags),
        thumbnailUrl:          getViewThumbnailUrl(content.id, (M.toDate(content.modifiedTime) || M.toDateFromTimeOffsetObject(content.modifiedTime))),
        updatedAt:             M.toDate(content.modifiedTime) || M.toDateFromTimeOffsetObject(content.modifiedTime),
        usageInfoMaxValues:    <IViewUsageInfo> {},
        contentType:           'view',
        lastAccessedAt:        undefined, //missing
        workbook:{ //missing workbook information
            displayTabs:false,
            favorite: false,
            id: '0',
            numSheets:0,
            owner: UserMapper.mapOneOwnerFromCRASS(content)
        },
        usageInfo:              <IViewUsageInfo>{
          hitsTotal: content.hitsTotal,
          hitsLastTwoWeeksTotal: content.hitsLastTwoWeeksTotal,
          hitsLastOneMonthTotal: content.hitsSmallSpanTotal,
          hitsLastThreeMonthsTotal: content.hitsMediumSpanTotal,
          hitsLastTwelveMonthsTotal: content.hitsLargeSpanTotal,
          favoritesTotal: content.favoritesTotal,
          subscriptionsTotal: content.subscriptionsTotal
        },
        owner: UserMapper.mapOneOwnerFromCRASS(content)
      };
  }

  function getViewThumbnailUrl(viewId: String, updatedAt: Date){
    const cacheValue = updatedAt ? updatedAt.getTime() : '';
    return M.REST_API_BASE_URL + `views/${viewId}/thumbnail?${cacheValue}`;
  }

}
